$(function() {
  var $header = $('#top-head');
  // Nav Toggle Button
  $('#nav-toggle').click(function(){
    $header.toggleClass('open');
    $header.addClass('fade');
  });

  $('#global-nav li a').on('click', function(){
      $('#nav-toggle').click();
  });
});

$(function () {
    $('#copy-url').click(function () {
        // data-urlの値を取得
        const url = $(this).data('url');

        // クリップボードにコピー
        navigator.clipboard.writeText(url);

        // フラッシュメッセージ表示
        $('.success-msg').fadeIn("slow", function () {
            $(this).delay(2000).fadeOut("slow");
        });
    });
});